import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import ButtonSp from '../../components/ButtonSp';

import InputTextSp from '../../components/InputTextSp';
import LabelSp from '../../components/LabelSp';
import { showMessage } from '../../components/MessageDialog';

import ModuloService from '../../services/ModuloService';

import { errorHandle, validateFields } from '../../util/functions';
import { ModuloModel } from '../../util/Models';
import { StateScreen } from '../constants';
import InputCurrencySp from '../../components/InputCurrencySp';

function ModuloCrud(props) {
  ModuloCrud.propTypes = {
    stateScreen: PropTypes.string.isRequired,
    idSelected: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  ModuloCrud.defaultProps = {
    messageConfirmation: 'Confirma os dados',
    showConfirmation: false,
  };

  const { stateScreen, idSelected, onClose } = props;

  // states
  const [modulo, setModulo] = useState(new ModuloModel());

  const [errorLoadRecord, setErrorLoadRecord] = useState(false);

  // useCallbacks

  const loadRecord = useCallback(async _id => {
    try {
      const retorno = await ModuloService.findById(_id);

      setModulo(retorno);

      setErrorLoadRecord(false);
    } catch (err) {
      setErrorLoadRecord(true);
      errorHandle(err);
    }
  }, []);

  // funcoes
  function viewMode() {
    return stateScreen === StateScreen.stView || errorLoadRecord;
  }

  function handleBack() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      showMessage('Confirmação', 'Abandonar mudanças?', idx => {
        if (idx === 1) {
          onClose();
        }
      });
    }
  }

  function handleSave() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      salvarRecord();
    }
  }

  async function salvarRecord() {
    try {
      let retorno;
      if (stateScreen === StateScreen.stInsert) {
        retorno = await ModuloService.insert(modulo);
      } else {
        retorno = await ModuloService.update(modulo);
      }
      toast.success('Registro salvo com sucesso.');
      onClose(retorno);
    } catch (err) {
      errorHandle(err);
    }
  }

  // useEffects
  useEffect(() => {
    if (stateScreen === StateScreen.stUpdate || stateScreen === StateScreen.stView) {
      loadRecord(idSelected);
    } else if (stateScreen === StateScreen.stInsert) {
      const novo = new ModuloModel();

      setModulo(novo);
    }
  }, [loadRecord, idSelected, stateScreen]);

  // render principal
  return (
    <>
      <>
        <div className="p-col-12 p-sm-4 p-lg-4 p-fluid">
          <LabelSp>Nome</LabelSp>
          <InputTextSp
            autoFocus
            value={modulo.nome}
            maxLength={100}
            required
            disabled={viewMode()}
            onChange={e => {
              setModulo({ ...modulo, nome: e.target.value });
            }}
          />
        </div>
        <div className="p-col-12 p-sm-5 p-lg-5 p-fluid">
          <LabelSp>Descrição</LabelSp>
          <InputTextSp
            value={modulo.descricao}
            maxLength={100}
            disabled={viewMode()}
            onChange={e => {
              setModulo({ ...modulo, descricao: e.target.value });
            }}
          />
        </div>

        <div className="p-col-3 p-md-3 p-lg-3 p-fluid">
          <LabelSp>%Desconto</LabelSp>
          <InputCurrencySp
            digits={4}
            disabled={viewMode()}
            onChange={(e, v) => {
              const percComissao = v >= 0 ? v : 0;
              setModulo({ ...modulo, percComissao });
            }}
            value={modulo.percComissao}
          />
        </div>

        <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
          {!viewMode() ? (
            <ButtonSp
              className="p-button-success"
              icon="pi pi-save"
              label="Salvar"
              keyAccess="S"
              disabled={!validateFields(modulo, ['nome'])}
              showConfirmation
              onClick={handleSave}
            />
          ) : null}
          <ButtonSp
            className="p-button-secondary"
            label="Voltar"
            icon="pi pi-chevron-circle-left"
            keyAccess="V"
            onClick={handleBack}
          />
        </div>
      </>
    </>
  );
}

export default ModuloCrud;
